const dateFormat = new Intl.DateTimeFormat('fr-BE', {
  weekday: 'short',
  day: 'numeric',
  month: 'long',
});
const timeFormat = new Intl.DateTimeFormat('fr-BE', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});
const moneyFormat = new Intl.NumberFormat('fr-BE', {
  style: 'currency',
  currency: 'EUR',
});

const capitalize = (text: string) =>
  text.charAt(0).toUpperCase() + text.slice(1);

export const formatDate = (timestamp: number) =>
  capitalize(dateFormat.format(timestamp));

export const formatTime = (timestamp: number) => timeFormat.format(timestamp);

// « lun. 24 août · 15:50 » : la date de retrait dit en minuscules dans une phrase.
export const formatPickup = (timestamp: number) =>
  `${formatDate(timestamp).toLowerCase()} · ${formatTime(timestamp)}`;

export const formatDateTime = (timestamp: number) =>
  `${formatDate(timestamp)} · ${formatTime(timestamp)}`;

// « Lun. 24 août à 15:34 » : l'instant où quelque chose est arrivé, pas une échéance.
export const formatFullDateTime = (timestamp: number) =>
  `${formatDate(timestamp)} à ${formatTime(timestamp)}`;

export const formatMoney = (cents: number) => moneyFormat.format(cents / 100);
